import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { NavigationService } from '@services/navigation-service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { PATH_ADMINISTRACION } from '../../../navigation/navigation.module';
import { PermisosService, PERM_ACCIONES_ID } from '@services/permisos-service';
import {FirebaseMessagingService} from '@services/firebase-messaging.service';
import {DolarizacionComponent} from '../dolarizacion';
import {RemitosHomeComponent} from '../remitos';
import {RemitosService} from '@services/remitos-service';
import {Subscription} from 'rxjs/Subscription';

@Component({
  selector: 'app-administracion-header',
  templateUrl: './administracion-header.component.html',
  styleUrls: ['./administracion-header.component.scss']
})
export class AdministracionHeaderComponent implements OnDestroy {

  selectedTabIndex = 0;

  @ViewChild(DolarizacionComponent) dolarizacionTab: DolarizacionComponent;
  @ViewChild(RemitosHomeComponent) remitosTab: RemitosHomeComponent;

  /** Cada vez que se agregue una nueva Tab, actualizar la lista para tener tracking de index y URL **/
  tabs = {
    remitos: 'remitos',
    dolarizacion: 'dolarizacion',
  };

  // tomamos el objeto de tabs para obtener el array de nombres
  adminTabs = [this.tabs.remitos, this.tabs.dolarizacion];

  remitoAdmin = false;
  subRemito: Subscription;

  constructor(private router: Router,
              private navigationService: NavigationService,
              private location: Location,
              private permisosService: PermisosService,
              private firebaseService: FirebaseMessagingService,
              private remitosService: RemitosService,
  ) {

    this.subRemito = remitosService.remitosValidated.subscribe(x => {
      this.remitoAdmin = x.Admin;
    });

    this.permisosService.verificarAccesoDeURL();

    this.adminTabs = this.permisosService.tabsPermitidas(
      this.adminTabs,
      [PERM_ACCIONES_ID.P_Remito, PERM_ACCIONES_ID.P_Administracion_Dolarizacion],
      [this.tabs.remitos, this.tabs.dolarizacion]
    );
    const splitURL = this.router.url.split('?')[0].substr(1).split('/');
    // seleccionamos la tab y la URL
    if (splitURL.length === 2) {
      const index = this.adminTabs.indexOf(splitURL[1]);
      this.selectedTabIndex = index;
      if (index !== 0) {
        this.selectTab(index);
      }
    } else {
      // default
      this.selectedTabIndex = 0;
      this.selectTab(0);
    }
  }

  ngOnDestroy() {
    this.subRemito.unsubscribe();
  }

  toggleNav() {
    this.navigationService.toggleNav(true);
  }

  selectTab(e) {
    const newLocation = `/${PATH_ADMINISTRACION}/${this.adminTabs[e]}`;
    this.location.go(newLocation);

    // Analytics
    this.firebaseService.sendToAnalytics(newLocation);
  }

  tabExists(tab: string): boolean {
    return this.adminTabs.indexOf(tab) !== -1;
  }

  // verificamos si la tab existe y está seleccionada en este momento
  tabExistsAndSelected(tab: string): boolean {
    return this.tabExists(tab) && this.selectedTabIndex === this.adminTabs.indexOf(tab);
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/administracion/administracion-header/administracion-header.component.ts